import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-722fdeb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_2 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl md:text-xl font-bold" }, "Fremdleitungen", -1))
const _hoisted_4 = { class: "content h-full max-h-full" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-8 justify-items-stretch items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, "Fremdleitungen"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold col-span-3 border-solid rounded-md whiteYellowBorderColor" }, "Beschreibung/Eingabewerte"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, "Weitere Eingaben"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span- text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, "Bewertung")
], -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-2 text-xs col-span-1" }, "Typ:", -1))
const _hoisted_8 = { class: "text-xs text-gray-500 capitalize" }
const _hoisted_9 = {
  key: 0,
  class: "ml-2 text-xs md:text-sm"
}
const _hoisted_10 = {
  key: 1,
  class: "text-xs text-gray-500 col-span-2 capitalize"
}
const _hoisted_11 = {
  key: 2,
  class: "text-xs text-gray-500 col-span-2 capitalize"
}
const _hoisted_12 = {
  key: 3,
  class: "text-xs text-gray-500 col-span-3"
}
const _hoisted_13 = { class: "justify-self-end col-span-3" }
const _hoisted_14 = {
  key: 4,
  class: "text-xs col-span-2"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-xs text-gray-500" }, /*#__PURE__*/_toDisplayString('\u{2611}'), -1))
const _hoisted_16 = {
  key: 5,
  class: "ml-2 text-xs col-span-2"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-gray-500" }, /*#__PURE__*/_toDisplayString('\u{2610}'), -1))
const _hoisted_18 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-2 text-xs col-span-2" }, "Betroffene Fläche:", -1))
const _hoisted_20 = { class: "ml-2 text-xs col-span-2" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2 grid grid-cols-8 justify-items-stretch items-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "justify-center items-center col-span-8",
    style: {"background-color":"rgb(235, 239, 240)","border-style":"solid","border-color":"rgb(235, 239, 240) rgb(235, 239, 240) rgb(235, 239, 240) rgb(235, 239, 240)","border-radius":"5px"}
  }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-center" }, "Keine Fremdleitungen aufgenommen")
  ])
], -1))
const _hoisted_23 = [
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tng_header = _resolveComponent("tng-header")!
  const _component_PdfChip = _resolveComponent("PdfChip")!
  const _component_be_footer = _resolveComponent("be-footer")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFremdleitungenPages(_ctx.ba), (fremdleitungPage, key) => {
    return (_openBlock(), _createBlock(_component_pdf_a4_page, {
      "no-margin": "",
      "pdf-key": _ctx.lang,
      key: key
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_tng_header, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang
            }, null, 8, ["ba", "immobilie", "lang"]),
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              (fremdleitungPage['fremdleitungen'].length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fremdleitungPage['fremdleitungen'], (fremdleitung, key) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: key,
                        class: "ml-2 mt-2 grid grid-cols-8 justify-items-stretch items-center gap-y-3",
                        style: {"border-style":"solid","border-color":"var(--white100) var(--white100) var(--white100) rgb(216, 215, 26)","border-radius":"5px"}
                      }, [
                        _hoisted_7,
                        _createElementVNode("div", _hoisted_8, _toDisplayString(fremdleitung['typ']), 1),
                        (fremdleitung['typ'] != 'unbekannt')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Art:"))
                          : _createCommentVNode("", true),
                        (fremdleitung['art-oberirdisch'] && fremdleitung['typ'] != 'unbekannt')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(fremdleitung['art-oberirdisch']), 1))
                          : (fremdleitung['art-unterirdisch'] &&fremdleitung['typ'] != 'unbekannt')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(fremdleitung['art-unterirdisch']), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_12, "  ")),
                        _createElementVNode("div", _hoisted_13, [
                          ('plus' === fremdleitung['fremdleitung-bewertung'])
                            ? (_openBlock(), _createBlock(_component_PdfChip, {
                                key: 0,
                                color: "green",
                                "mangel-amount-mode": "",
                                value: "1",
                                "pdf-mode": ""
                              }))
                            : _createCommentVNode("", true),
                          ('o' === fremdleitung['fremdleitung-bewertung'])
                            ? (_openBlock(), _createBlock(_component_PdfChip, {
                                key: 1,
                                color: "blue",
                                "mangel-amount-mode": "",
                                value: "1",
                                "pdf-mode": ""
                              }))
                            : _createCommentVNode("", true),
                          ('minus' === fremdleitung['fremdleitung-bewertung'])
                            ? (_openBlock(), _createBlock(_component_PdfChip, {
                                key: 2,
                                color: "yellow",
                                "mangel-amount-mode": "",
                                value: "1",
                                "pdf-mode": ""
                              }))
                            : _createCommentVNode("", true),
                          ('x' === fremdleitung['fremdleitung-bewertung'])
                            ? (_openBlock(), _createBlock(_component_PdfChip, {
                                key: 3,
                                color: "red",
                                "mangel-amount-mode": "",
                                value: "1",
                                "pdf-mode": ""
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        (fremdleitung['betreiber-bekannt'])
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _hoisted_15,
                              _createTextVNode(" Betreiber bekannt ")
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _hoisted_17,
                              _createTextVNode(" Betreiber unbekannt ")
                            ])),
                        _createElementVNode("div", _hoisted_18, _toDisplayString(fremdleitung['betreiber']), 1),
                        _hoisted_19,
                        _createElementVNode("div", _hoisted_20, _toDisplayString(fremdleitung['betroffeneflaechen']), 1)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
            ]),
            _createVNode(_component_be_footer, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang
            }, null, 8, ["ba", "immobilie", "lang"])
          ])
        ])
      ]),
      _: 2
    }, 1032, ["pdf-key"]))
  }), 128))
}